import * as PopoverPrimitive from "@radix-ui/react-popover";
import classNames from "classnames";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { ParentComlinkAPI } from "./FrameSandboxAPI";

const TextLinkClassName =
  "text-neutral-500 hover:text-neutral-700 hover:underline transition";

function AboutPanel({ onClose }: { onClose: () => void }) {
  const [lastBuildString] = useState(() => {
    const buildDate = new Date(VITE_APP_BUILD_TIME);
    return `${buildDate.getMonth() + 1}/${buildDate.getDate()}`;
  });
  const history = useHistory();
  return (
    <div className={classNames()}>
      <div className="bg-neutral-0 rounded-lg w-80 max-w-[100vw] px-6 py-4 shadow-lg relative select-none">
        <div className="natto-icon mx-auto mb-4 relative left-[30px]" />
        <div className="mb-4 text-center">
          <div className="text-secondary-700 font-mono-natto text-lg">
            natto.dev
          </div>
          <div className="text-neutral-500">
            write JavaScript on a 2D canvas
          </div>
        </div>
        <div className="mb-4 text-neutral-300">
          <div>
            {"→ "}
            <button
              onClick={() => {
                ParentComlinkAPI.showCanvasSelector();
                onClose();
              }}
              className={TextLinkClassName}
            >
              examples
            </button>
          </div>
          <div>
            {"→ "}
            <a
              href="/tutorial/tip-calculator"
              onClick={(e) => {
                e.preventDefault();
                ParentComlinkAPI.navigateCanvas(["tutorial", "tip-calculator"]);
                onClose();
              }}
              className={TextLinkClassName}
            >
              interactive tutorial
            </a>
          </div>
          <div>
            {"→ "}
            <a
              href="https://www.notion.so/paulshen/Documentation-44fea11f393a4e46b5a22f5799de58ca"
              target="_blank"
              rel="noreferrer"
              className={TextLinkClassName}
            >
              documentation
            </a>
          </div>
          <div>
            {"→ "}
            <a
              href="https://www.notion.so/paulshen/Changelog-9fd553d862244750a8ee0c679956afd2"
              target="_blank"
              rel="noreferrer"
              className={TextLinkClassName}
            >
              changelog
            </a>
            <span className="text-neutral-400 ml-1">
              (code update {lastBuildString})
            </span>
          </div>
          <div>
            {"→ "}
            <a
              href="https://discord.com/invite/2GGMn7fTKQ"
              target="_blank"
              rel="noreferrer"
              className={TextLinkClassName}
            >
              discord
            </a>
          </div>
        </div>
        <div className="mb-4">
          Let's explore the future of code. Follow updates and send feedback{" "}
          <a
            href="https://twitter.com/_paulshen"
            target="_blank"
            rel="noreferrer"
            className="text-primary-500 underline"
          >
            @_paulshen
          </a>
        </div>
      </div>
    </div>
  );
}

export function AboutButton() {
  const [showPopover, setShowPopover] = useState(false);
  return (
    <div className="fixed bottom-4 right-4">
      <PopoverPrimitive.Root
        modal={true}
        open={showPopover}
        onOpenChange={(open) => {
          setShowPopover(open);
        }}
      >
        <PopoverPrimitive.Trigger asChild={true}>
          <button className="bg-neutral-100 hover:bg-neutral-0 radix-open:bg-neutral-0 rounded-full w-8 h-8 flex items-center justify-center text-neutral-600 shadow transition">
            ?
          </button>
        </PopoverPrimitive.Trigger>
        <PopoverPrimitive.Portal>
          <PopoverPrimitive.Content
            side="top"
            sideOffset={8}
            align="end"
            className="popover-animate-in"
          >
            <AboutPanel
              onClose={() => {
                setShowPopover(false);
              }}
            />
          </PopoverPrimitive.Content>
        </PopoverPrimitive.Portal>
      </PopoverPrimitive.Root>
    </div>
  );
}
